import {
  DatabaseView,
  DEFAULT_DATABASE_VIEW_SETTINGS,
} from '@databases/types/database/view';
import { proxy } from 'valtio';
import { devtools } from 'valtio/utils';

export const viewState = proxy<{ view: DatabaseView }>({
  view: {
    id: '',
    name: '',
    settings: DEFAULT_DATABASE_VIEW_SETTINGS,
  },
});

export const setView = (view: DatabaseView) => {
  viewState.view = view;
};

if (process.env.NODE_ENV === 'development') {
  devtools(viewState, 'Valtio View State');
}
